import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from "@angular/forms";

import { CotizadorRoutingModule } from './cotizador-routing.module';

import { MaterialModule } from '../../material/material.module';
import { PipeModule } from '../../pipe/pipe.module';
import { PraxisModule } from './praxis/praxis.module';
import { CotizadorComponent } from './cotizador.component';
import { MantenimientoComponent } from '../../mantenimiento/mantenimiento.component';
import { PrepagaModule } from './prepaga/prepaga.module';
import { SharedModule } from '../../shared/shared-module.module';



@NgModule({
  declarations: [CotizadorComponent, MantenimientoComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    CotizadorRoutingModule,
    PraxisModule,
    PrepagaModule,
    MaterialModule,
    PipeModule
    ,
    SharedModule

  ],
  exports: [CotizadorComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class CotizadorModuleModule { }
